import type { CosmicBelowFoldWhySectionType } from '@/lib/cms/cosmic/types/CosmicBelowFoldType'
import { ProductTwoColumnBannerSection } from './ProductTwoColumnBannerSection'

type Props = {
  whySections?: CosmicBelowFoldWhySectionType[]
}

export const WhySections = ({ whySections }: Props) => {
  if (!whySections || whySections.length === 0) return null

  return (
    <>
      {whySections.map((section, index) => (
        <ProductTwoColumnBannerSection
          key={index}
          headerText={section.title}
          headerTextColor={section.titleTextColor}
          content={section.content}
          imageSrc={section.image}
          imageAlt={section.altText || section.title}
          backgroundColor={section.backgroundColor ?? '#ffffff'}
          isImgFirst={section.imagePlacement === 'left'}
        />
      ))}
    </>
  )
}
